import { FC, useEffect, useState } from "react";
import OperatorForm, { OperatorFormValues } from "../operator-form";
import { Link } from "react-router";

interface Props {
    operatorId?: number;
    operatorFullName?: string;
    onSubmit: (_form: OperatorFormValues) => void;
}

const OperatorField:FC<Props> = ({ operatorId, operatorFullName, onSubmit }) => {
    const [isFormVisible, setIsFormVisible] = useState(false);
    const formId = "assignOperatorForm";

    const showForm = (e) => {
        e.stopPropagation();
        e.preventDefault();
        setIsFormVisible(true);
    };

    useEffect(() => {
        setIsFormVisible(false);
    }, [operatorId]);

    return (
        <div className="info-field mb-4">
            <div className="d-flex justify-content-between justify-content-center">
                <h5 className="field-title d-flex justify-content-between align-items-center">
                    Operator
                </h5>
                {operatorId && !isFormVisible && (
                    <a
                        role="button"
                        aria-expanded={isFormVisible}
                        aria-controls={formId}
                        className="text-primary"
                        onClick={showForm}
                    >Edit</a>
                )}
            </div>

            {isFormVisible
                ? (
                    <OperatorForm
                        id={formId}
                        value={operatorId}
                        onSubmit={onSubmit}
                    />
                )
                : (
                    <>

                        {operatorId
                            ? (
                                <div className="field-value">
                                    <Link
                                        to={`/users/${operatorId}`}
                                    >{operatorFullName}</Link>
                                </div>
                            )
                            : (
                                <a
                                    role="button"
                                    aria-expanded={isFormVisible}
                                    aria-controls={formId}
                                    className="text-primary"
                                    onClick={showForm}
                                >
                                    Assign
                                </a>
                            )
                        }
                    </>
                )
            }
        </div>
    );
};

export default OperatorField;
